import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, setStoredToken } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { navigate("/"); return; }
    const sessionId = m[1];

    (async () => {
      try {
        const r = await api.post("/auth/session", null, {
          headers: { "X-Session-ID": sessionId },
        });
        // Persist the session token for cross-origin (custom domain) safety.
        if (r.data?.session_token) setStoredToken(r.data.session_token);
        setUser(r.data.user);
        // strip hash and go home
        window.history.replaceState(null, "", "/");
        navigate("/", { replace: true, state: { user: r.data.user } });
      } catch (err) {
        setError(err.response?.data?.detail || err.message || "Auth failed");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center text-[#4A4A45]">
      {error ? (
        <div className="text-center" data-testid="auth-error">
          <p className="font-heading font-bold text-xl">Klaida</p>
          <p className="text-sm mt-2">{error}</p>
        </div>
      ) : (
        <p className="text-sm">...</p>
      )}
    </div>
  );
}
